import { http } from '../utils/http'

const searchMsgOverviewAction = (params, pageNo, pageSize) => {
    params.page = pageNo
    params.size = pageSize
	const url = `/monitor/messageOverview/apiInformationSearch`
    // const url = `/open/api/v1/push-log/request-log/overview?page=${pageNo}&size=${pageSize}`
  return http.post(url, params)
}
const getMessageIds = (params) => {
    const url = `/monitor/messageOverview/apiInformationSearch/messageIds`
    // const url = `/open/api/v1/push-log/request-log/overview?page=${pageNo}&size=${pageSize}`
    return http.post(url, params)
}
const searchMsgOverviewIdentificationAction = (params, pageNo, pageSize) => {
    params.page = pageNo
    params.size = pageSize
  const url = '/monitor/messageOverview/identificationSearch'
  // const url = '/open/api/v1/push-log/request-log/overview/identification'
  return http.post(url, params)
}
const searchMsgOverviewIndexNameAction = (params) => {
  const url = `/config/indexManagement/findName`
  return http.post(url, params)
}
const searchMsgOverviewIndexAction = (params, pageNo, pageSize) => {
    params.page = pageNo
    params.size = pageSize
  const url = `/monitor/messageOverview/indexSearch`
  // const url = `/open/api/v1/index-search/overview/get/index`
  return http.post(url, params)
}
const searchMsgListAction = (params, pageNo, pageSize) => {
    params.page = pageNo
    params.size = pageSize
    const url = `/monitor/messageOverview/apiInformationSearch/details`
  // const url = `/open/api/v1/push-log/request-log/list?page=${pageNo}&size=${pageSize}`
  return http.post(url, params)
};
const searchMsgListIdentificationAction = (params, pageNo, pageSize) => {
    params.page = pageNo
    params.size = pageSize
    const url = `/monitor/messageOverview/identificationSearch/details`
    // const url = '/open/api/v1/push-log/request-log/details/identification'
  return http.post(url, params)
};
const searchMsgListIndexAction = (params, pageNo, pageSize) => {
    params.page = pageNo
    params.size = pageSize
  const url = `/monitor/messageOverview/indexSearch/details`
  // const url = `/open/api/v1/index-search/details/get/index`
  return http.post(url, params)
}
const searchMsgLogAction = (requestId) => {
	const url = `/monitor/messageOverview/apiInformationSearch/details/steps/${requestId}`
	// const url = `/open/api/v1/push-log/request-log/details/find-step-message/${requestId}`
  return http.post(url)
}
const searchMsgDetailLogAction = (params, pageNo, pageSize) => {
    params.page = pageNo
    params.size = pageSize
  // const url = `/open/api/v1/push-log/list?page=${pageNo}&size=${pageSize}&sort=createTime,DESC&sort=order,DESC`
  const url = `/monitor/messageOverview/apiInformationSearch/detail/steps`
  return http.post(url, params)
}
const searchMsgDetailFormatAction = (params) => {
    // const url = `/open/api/v1/push-log/operation/log/get`
    // return http.post(url, params)
  const url = `/monitor/messageOverview/apiInformationSearch/detail/${params.messageId}`
  return http.post(url, {})
}
const resendMsgAction = (params) => {
	const url = `/monitor/messageOverview/apiInformationSearch/resend`
	// const url = `/open/api/v1/push-log/operation/resend`
  return http.post(url, params)
}
const resendScheduledAction = (params) => {
  const url = `/open/api/v1/resend/skip/scheduled/send`
  return http.post(url, params)
}
const searchPayloadDetailAction = (logId) => {
	const url = `/open/api/v1/push-log/payload/${logId}/get`
  return http.post(url, {})
}

export default {
	searchMsgOverviewAction,
	searchMsgOverviewIdentificationAction,
  searchMsgOverviewIndexNameAction,
  searchMsgOverviewIndexAction,
	searchMsgListAction,
  searchMsgListIdentificationAction,
  searchMsgListIndexAction,
	searchMsgLogAction,
  searchMsgDetailLogAction,
	resendMsgAction,
  resendScheduledAction,
	searchPayloadDetailAction,
  searchMsgDetailFormatAction,
    getMessageIds
}
